module.exports = {
  "zones": {
    "America/Ojinaga": ["z", {
      "wallclock": 1262304000000,
      "format": "M%sT",
      "abbrev": "MST",
      "offset": -25200000,
      "posix": 1262329200000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": 891745200000,
      "format": "M%sT",
      "abbrev": "MDT",
      "offset": -25200000,
      "posix": 891766800000,
      "save": 3600000,
      "rules": "Mexico"
    }, {
      "wallclock": 883612800000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": 883634400000,
      "save": 0
    }, {
      "wallclock": 820454400000,
      "format": "C%sT",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": 820476000000,
      "save": 0,
      "rules": "Mexico"
    }, {
      "wallclock": -1191369600000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -1191344400000,
      "save": 0
    }, {
      "wallclock": -1207180800000,
      "format": "MST",
      "abbrev": "MST",
      "offset": -25200000,
      "posix": -1207159200000,
      "save": 0
    }, {
      "wallclock": -1220317200000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -1220292000000,
      "save": 0
    }, {
      "wallclock": -1234828800000,
      "format": "MST",
      "abbrev": "MST",
      "offset": -25200000,
      "posix": -1234807200000,
      "save": 0
    }, {
      "wallclock": -1343091600000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -1343066400000,
      "save": 0
    }, {
      "wallclock": -1514764660000,
      "format": "MST",
      "abbrev": "MST",
      "offset": -25200000,
      "posix": -1514739600000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -25060000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "US": [{
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1967,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1987,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1975,
      "to": 1975,
      "month": 1,
      "day": [7, 23],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 0,
      "day": [7, 6],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1967,
      "to": 1973,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 7,
      "day": [7, 14],
      "time": 1380,
      "clock": "posix",
      "save": 60,
      "letter": "P",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 1,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }],
    "Mexico": [{
      "from": 2002,
      "to": 1.7976931348623157e+308,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2002,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 2001,
      "to": 2001,
      "month": 4,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2001,
      "to": 2001,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1996,
      "to": 2000,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2000,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1950,
      "to": 1950,
      "month": 1,
      "day": [7, 12],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1950,
      "to": 1950,
      "month": 6,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1944,
      "to": 1944,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1943,
      "month": 11,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1941,
      "to": 1941,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1940,
      "to": 1940,
      "month": 11,
      "day": [7, 9],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 1,
      "day": [7, 5],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 5,
      "day": [7, 25],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }]
  }
};